"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  root: {
    height: function height(_ref) {
      var uncontained = _ref.uncontained;
      return uncontained ? '100%' : '';
    },
    width: function width(_ref2) {
      var uncontained = _ref2.uncontained;
      return uncontained ? '100%' : '';
    }
  },
  targetContainer: {
    height: function height(_ref3) {
      var uncontained = _ref3.uncontained;
      return uncontained ? '100%' : '';
    },
    width: function width(_ref4) {
      var uncontained = _ref4.uncontained;
      return uncontained ? '100%' : '';
    }
  },
  popperContainer: {
    width: '100%',
    transition: function transition(_ref5) {
      var disableTransitions = _ref5.disableTransitions;
      return disableTransitions ? '' : 'opacity 0.3s';
    }
  },
  transitionIn: {
    opacity: 1
  },
  transitionOut: {
    opacity: 0
  }
};
var _default = styles;
exports["default"] = _default;